export default {
	nodata: {
		error: 'An error has occurred, please try again later',
		loading: 'Loading data',
		no_data: 'No data available',
		noDataLoaded: 'No {name} loaded',
	},
}
